import React from 'react';
import { Row, Cell } from 'src/Components/Common/Table/TableRow/styles';
var PaymentsTableRow = function (_a) {
    var _b = _a.data, receipt_number = _b.receipt_number, numeric_client_code = _b.numeric_client_code, amount = _b.amount, payed_at = _b.payed_at, status = _b.status, payment_method = _b.payment_method, widths = _a.widths;
    var cellsData = [receipt_number, numeric_client_code, amount, payed_at, status, payment_method];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { hover: true, tabIndex: -1 }, cellsData.map(function (item, index) { return (React.createElement(Cell, { className: 'left', key: item, style: { width: widths[index] } }, item)); }))));
};
export default PaymentsTableRow;
